/**
 * @module Sagas/Card
 * @desc Card
 */

import { put, call } from 'redux-saga/effects';
import { getAllRewardsSuccess, getAllRewardsFailure, showAlert } from 'actions/index';

export function* getAllRewardsRequest(api, action) {
  const { status, data } = yield call(api.getAllRewards, action.payload);
  if (status === 200) {
    yield put(getAllRewardsSuccess(data.data));
  } else {
    const msg = data?.error?.message;
    const isArray = Array.isArray(msg);
    const isString = typeof msg === 'string';
    const display = isArray ? msg.join(', ') : isString ? msg : 'Failed to load rewards';
    yield put(showAlert(display, { variant: 'danger' }));
    yield put(getAllRewardsFailure());
  }
}
